import { combineForms } from 'react-redux-form';

const loginForm = {
    UserId: '',
    Password: ''
};

const plantForm = {
    PlantId: '',
    Plant_Region: '',
    Plant_Name: '',
    Street: '',
    City: '',
    State: '',
    Zip: '',
    Country: '',
    Outfalls: '',
    Inspections: '',
};

const updatePlantForm = {
    Plant_Region: '',
    Plant_Name: '',
    Street: '',
    City: '',
    State: '',
    Zip: '',
    Country: '',
    Outfalls: [],
    Inspections: [],
};

const userForm = {
    UserId: '',
    Password: '',
    First_Name: '',
    Last_Name: '',
    Email: '',
    Access_Level: '',
    Plants: [],
    Job_Title: '',
    Job_Desc: '',
};

const QTRVisualForm = {

};

const updateUserForm = {
    First_Name: '',
    Middle_Name: '',
    Last_Name: '',
    Email: '',
    Access_Level: '',
    Plants: [],
    Job_Title: '',
    Job_Desc: '',
};

function constructObject(length) {
    let obj = {};
    for (let index = 1; index <= length; index++) {
        Object.assign(obj, { [index]: null });
    }
    return obj;
}

const supportForm = {
    comments: ''
};

export const forms = combineForms({
    loginForm, plantForm, userForm, updateUserForm, monthlyForms: {}, updatePlantForm,
    dailyForm: constructObject(17), monthlySWForm: constructObject(60), monthlySPCCForm: constructObject(28),
    monthlyUSTSpill: constructObject(6), monthlySpillLogs: constructObject(4), monthlyUSTRect: constructObject(8),
    dailyPMForm: constructObject(54), QTRVisualForm: constructObject(24), 
    shopInspectionForm: constructObject(27), supportForm
}, 'forms');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/formReducer.ts